import { render, staticRenderFns } from "./CollegeSubscriptionVideosChild.vue?vue&type=template&id=3e60622c"
import script from "./CollegeSubscriptionVideosChild.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptionVideosChild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports